import React from 'react';
import { Modal } from './ui/Modal';
import { Calendar, Clock, Tag, Play, Video } from 'lucide-react';
interface VideoItem {
  id: string;
  title: string;
  thumbnailUrl: string;
  duration: string;
}
interface Article {
  id: string;
  title: string;
  content: string;
  excerpt: string;
  category: string;
  attachedVideoId: string | null;
  images: string[];
  dateAdded: string;
  readTime: string;
}
interface ArticleViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  article: Article | null;
  videos: VideoItem[];
  onPlayVideo?: (video: VideoItem) => void;
}
export function ArticleViewerModal({
  isOpen,
  onClose,
  article,
  videos,
  onPlayVideo
}: ArticleViewerModalProps) {
  if (!article) return null;
  const attachedVideo = videos.find(v => v.id === article.attachedVideoId);
  return <Modal isOpen={isOpen} onClose={onClose} title="" maxWidth="4xl" data-id="element-87">
      <article className="prose prose-sm sm:prose max-w-none" data-id="element-88">
        <div className="not-prose mb-6" data-id="element-89">
          <div className="flex items-center gap-3 text-sm text-gray-500 mb-3" data-id="element-90">
            <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-orange-50 text-orange-700 text-xs font-medium" data-id="element-91">
              <Tag className="w-3 h-3" data-id="element-92" />
              {article.category}
            </span>
            <span className="flex items-center gap-1" data-id="element-93">
              <Clock className="w-4 h-4" data-id="element-94" />
              {article.readTime}
            </span>
            <span className="flex items-center gap-1" data-id="element-95">
              <Calendar className="w-4 h-4" data-id="element-96" />
              {new Date(article.dateAdded).toLocaleDateString()}
            </span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-tight" data-id="element-97">
            {article.title}
          </h1>
        </div>
        {attachedVideo && <div className="not-prose mb-6" data-id="element-98">
            <div className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2" data-id="element-99">
              <Video className="w-4 h-4" data-id="element-100" />
              Related Video
            </div>
            <button onClick={() => onPlayVideo?.(attachedVideo)} className="group relative w-full max-w-md aspect-video rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-101">
              <img src={attachedVideo.thumbnailUrl} alt={attachedVideo.title} className="w-full h-full object-cover" data-id="element-102" />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-103">
                <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform" data-id="element-104">
                  <Play className="w-6 h-6 text-orange-600 ml-1" fill="currentColor" data-id="element-105" />
                </div>
              </div>
              <div className="absolute bottom-3 left-3 right-3" data-id="element-106">
                <p className="text-white font-medium text-sm text-left drop-shadow-lg" data-id="element-107">
                  {attachedVideo.title}
                </p>
                <p className="text-white/80 text-xs text-left" data-id="element-108">
                  {attachedVideo.duration}
                </p>
              </div>
            </button>
          </div>}
        <div className="article-content" dangerouslySetInnerHTML={{
        __html: article.content
      }} data-id="element-109" />
      </article>
    </Modal>;
}